var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuneral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.752 18.548l4.109-3.595a2.592 2.592 0 00-.666-4.317 33.662 33.662 0 00-13.857-2.858c-4.77-.04-9.493.934-13.857 2.858a2.592 2.592 0 00-.666 4.317l4.472 3.912c-5.923 3.72-11.225 10.213-11.225 17.62 0 13.125 10.464 43.738 10.464 43.738h20.948S64.939 49.61 64.939 36.484a20.896 20.896 0 00-10.186-17.936z",
    fill: "#FFD6C0",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.287 18.865a37.824 37.824 0 0120.465-.318",
    stroke: "#FFA5A5",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.986 72.357h26.028",
    stroke: "#FFA5A5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.01 36.083h39.98M24.01 41.663h39.327",
    stroke: "#FFA5A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.116 79.722l.002-.006c.076-.227.189-.561.331-.992a368.16 368.16 0 004.775-15.584c2.62-9.304 5.214-20.173 5.214-26.656L54.116 79.722zm0 0H46.8c.063-.19.14-.418.227-.683a369.532 369.532 0 004.789-15.628c2.613-9.283 5.25-20.284 5.25-26.927 0-3.873-.813-8.069-1.618-11.443-.33-1.385-.662-2.639-.935-3.676l-.171-.65a46.842 46.842 0 01-.36-1.436c-.02-.085-.036-.162-.05-.231h.68a20.395 20.395 0 019.826 17.436L54.116 79.722zM58.932 12.484c.092.113.168.212.227.291l-.03.076c-.078.203-.196.493-.348.835a16.634 16.634 0 01-1.293 2.393c-.552.83-1.184 1.549-1.856 1.95-.527.313-1.07.428-1.65.244.637-1.76 1.28-2.788 1.787-3.6.231-.369.434-.693.596-1.021.277-.565.4-1.118.188-1.8-.139-.45-.418-.935-.84-1.512.794.079 1.551.529 2.2 1.088.425.367.775.756 1.019 1.056z",
    fill: "#FFA5A5",
    stroke: "#FFA5A5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.706 18.548l4.155-3.595a2.592 2.592 0 00-.666-4.317 33.662 33.662 0 00-13.857-2.858c-4.77-.04-9.493.934-13.857 2.858a2.592 2.592 0 00-.666 4.317l4.472 3.912c-5.923 3.72-11.225 10.213-11.225 17.62 0 13.125 10.464 43.738 10.464 43.738h20.948S64.939 49.61 64.939 36.484a20.896 20.896 0 00-10.186-17.936h-.046z",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgFuneral;